export const articlesAnalysisPatterns = [
  {
    slug: 'head-and-shoulders',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'Head and Shoulders คืออะไร',
    description:
      'อ่านรูปแบบ Head and Shoulders และรูปแบบกลับหัว พร้อมระดับคอที่ต้องรอ และเหตุผลที่รูปแบบนี้ล้มเหลวได้บ่อย',
    readingTime: '8 นาที',
    updatedDate: '2026-10-08',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20head%20and%20shoulders%20chart%20pattern%20illustration%20three%20teal%20peaks%20on%20clean%20light%20background%20with%20warm%20orange%20neckline%20editorial%20flat%20fintech%20no%20text&width=1200&height=675&seq=art-head-and-shoulders-01&orientation=landscape',
    tags: ['รูปแบบกราฟ', 'กลับตัว', 'Head and Shoulders'],
    intro: [
      'Head and Shoulders คือรูปแบบกลับตัวที่ประกอบด้วยยอดสามยอด โดยยอดกลางสูงที่สุดและสองข้างสูงใกล้เคียงกัน',
      'รูปแบบนี้บอกว่าแรงผลักดันฝั่งเดิมอ่อนลงทีละขั้น แต่การกลับตัวจะเกิดขึ้นจริงก็ต่อเมื่อราคาผ่านระดับคอ',
    ],
    sections: [
      {
        id: 'shape',
        heading: 'องค์ประกอบของรูปแบบ',
        paragraphs: [
          'ไหล่ซ้ายคือยอดแรกที่ถูกปฏิเสธ หัวคือยอดที่สูงกว่า และไหล่ขวาคือยอดที่สูงใกล้เคียงไหล่ซ้ายแต่ไม่ผ่านหัว ระดับคอคือเส้นเชื่อมจุดต่ำระหว่างยอดทั้งสาม',
        ],
        bullets: ['ไหล่สองข้างไม่จำเป็นต้องสูงเท่ากันเป๊ะ', 'ปริมาณการแกว่งมักลดลงที่ไหล่ขวา', 'ระดับคอคือเกณฑ์ยืนยัน'],
        steps: [],
      },
      {
        id: 'inverse',
        heading: 'รูปแบบกลับหัว',
        paragraphs: [
          'Inverse Head and Shoulders คือภาพกลับด้านของรูปแบบนี้ ใช้ในบริบทปลายขาลง โดยมีหัวอยู่ต่ำสุดและไหล่สองข้างสูงกว่าเล็กน้อย',
        ],
        bullets: ['ใช้ในบริบทขาลงเพื่อมองการกลับขึ้น', 'ต้องมีระดับคอให้ผ่านก่อน', 'ควรตรวจกรอบเวลาใหญ่ประกอบ'],
        steps: [],
      },
      {
        id: 'fail',
        heading: 'ทำไมรูปแบบถึงล้มเหลว',
        paragraphs: [
          'ตลาดไม่ได้ทำตามรูปแบบที่เราวาด การจับรูปแบบจากยอดที่คล้ายกันโดยไม่ดูบริบททำให้เห็นสัญญาณมากเกินจริง โดยเฉพาะในตลาดไซด์เวย์ที่ยอดเกิดซ้ำตลอดเวลา',
          'วิธีกรองที่ใช้ได้คือ รูปแบบต้องมีจุดสูงหรือจุดต่ำที่ต่างกันอย่างน้อย 2 ถึง 3% ไม่ใช่ห่างกันแค่ไม่กี่ Pip และต้องอยู่ใต้หรือเหนือแนวโน้มหลักบน H4 ในทิศทางเดียวกัน ถ้ารูปแบบเกิดในกรอบไซด์เวย์ที่มีความกว้างไม่ถึง 30 Pip โอกาสที่ราคาจะทะลุแล้วไปต่อจริงจะลดลงเกือบครึ่ง',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Head and Shoulders ต้องรอผ่านระดับคอก่อนไหม',
        a: 'ควรครับ การเข้าเร็วกว่านั้นคือการเดาการกลับตัว ซึ่งทำให้จุดผิดอยู่ห่างเกินไปและผลตอบแทนต่อความเสี่ยงแย่ลง',
        a2: 'ตัวเลขที่ควรรู้คือ เป้าหมายของรูปแบบวัดจากความสูงของหัวถึงระดับคอ และมักไปถึงเป้าเพียง 60-70% ของกรณี ส่วนการเข้าตอนไหล่ขวายังไม่ครบทำให้จุดผิดไกลกว่าปกติ 1.5-2 เท่า และ R:R ลดจาก 1:2 เหลือราว 1:1',
      },
      {
        q: 'ใช้กับกรอบเวลาไหนได้บ้าง',
        a: 'ใช้ได้ทุกกรอบ แต่รูปแบบบน H4 หรือ D1 มักมีความหมายมากกว่ารูปแบบบนกรอบนาทีที่เกิดซ้ำไม่หยุด',
        a2: 'ตัวเลขที่ต่างชัดคือ Head and Shoulders บน M15 เกิดวันละ 2-3 ครั้งและล้มเหลวราว 6 ใน 10 ครั้ง ส่วนบน H4 เกิดเดือนละ 2-4 ครั้งและสำเร็จราว 5-6 ใน 10 ครั้ง จึงควรใช้กรอบใหญ่หาและกรอบเล็กหาจุดเข้า',
      },
    ],
    related: ['double-top-double-bottom', 'chart-pattern-reading', 'support-resistance'],
  },
  {
    slug: 'triangle-pattern',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'Triangle Pattern คืออะไร',
    description:
      'รู้จักรูปแบบสามเหลี่ยมทั้งแบบสมมาตร ขึ้น และลง พร้อมวิธีอ่านการบีบตัวของราคาก่อนเลือกทิศทาง',
    readingTime: '7 นาที',
    updatedDate: '2026-10-07',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20triangle%20chart%20pattern%20illustration%20teal%20converging%20price%20swings%20inside%20warm%20orange%20wedge%20lines%20clean%20light%20background%20editorial%20flat%20fintech%20no%20text&width=1200&height=675&seq=art-triangle-pattern-01&orientation=landscape',
    tags: ['รูปแบบกราฟ', 'สามเหลี่ยม', 'บีบตัว'],
    intro: [
      'Triangle Pattern คือรูปแบบที่ราคาแกว่งแคบลงเรื่อย ๆ ระหว่างเส้นสองเส้นที่บรรจบกัน',
      'มันสะท้อนว่าตลาดกำลังลดความลังเลลง และมักจบด้วยการเลือกทิศทางใดทิศทางหนึ่ง',
    ],
    sections: [
      {
        id: 'types',
        heading: 'รูปแบบสามเหลี่ยมที่พบบ่อย',
        paragraphs: [
          'สามเหลี่ยมสมมาตรมีจุดสูงต่ำลงและจุดต่ำสูงขึ้นเท่า ๆ กัน ส่วนสามเหลี่ยมขึ้นมีขอบบนเกือบราบและขอบล่างยกขึ้น และสามเหลี่ยมลงกลับกัน',
        ],
        bullets: ['สมมาตร = ไม่เอนเอียงฝั่งใด', 'ขึ้น = มักไปทางขึ้นแต่ไม่เสมอ', 'ลง = มักไปทางลงแต่ไม่เสมอ'],
        steps: [],
      },
      {
        id: 'read',
        heading: 'อ่านอย่างไรให้ไม่เดา',
        paragraphs: [
          'จุดสำคัญคือการรอให้ราคาปิดพ้นขอบใดขอบหนึ่งอย่างชัดเจน และควรดูว่าการหลุดนั้นเกิดใกล้ปลายสามเหลี่ยมหรือไม่ เพราะการหลุดก่อนถึงครึ่งทางมักล้มเหลวง่าย',
        ],
        bullets: ['รอแท่งปิดพ้นขอบ', 'ระวังการหลุดปลอมช่วงปลายรูปแบบ', 'ดูทิศทางแนวโน้มใหญ่ประกอบ'],
        steps: [],
      },
      {
        id: 'risk',
        heading: 'ความเสี่ยงที่ต้องยอมรับ',
        paragraphs: [
          'รูปแบบสามเหลี่ยมบางครั้งจบด้วยการทะลุทั้งสองด้านสลับกัน ทำให้เกิดความเสียหายสองรอบ ควรกำหนดความเสี่ยงต่อออเดอร์ให้ชัดก่อนเสมอ',
          'สิ่งที่ควรรู้คือเมื่อราคาทะลุด้านหนึ่งแล้วกลับมาหลุดอีกด้านภายใน 5 ถึง 8 แท่งบน H4 มักหมายถึงสัญญาณหลอก ให้ยอมรับขาดทุนก้อนแรกและรอกรอบใหม่ ไม่ควรกลับไม้ทันทีในทิศตรงข้ามเพราะความผันผวนจะกว้างกว่าปกติ 1 ถึง 2 เท่าในช่วงที่ตลาดเลือกทาง',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'สามเหลี่ยมต้องทะลุทางไหน',
        a: 'ไม่มีกฎตายตัว สามเหลี่ยมขึ้นมีโอกาสไปทางขึ้นมากกว่าเล็กน้อย แต่ก็หลุดลงได้บ่อยพอที่จะต้องเตรียมแผนทั้งสองทาง',
        a2: 'ตัวเลขที่ใช้ได้คือ สามเหลี่ยมสมมาตรชนะราว 5 ใน 10 ครั้งทั้งสองทาง ซึ่งเท่ากับการเดา ถ้าจะเทรดต้องรอแท่งปิดพ้นขอบและตั้งจุดผิดไว้ที่กลางกรอบ ไม่ใช่ที่ขอบอีกด้าน เพราะจุดผิดแบบนั้นมักใหญ่เกิน 2 เท่าของเป้าหมาย',
      },
      {
        q: 'ต้องรอนานแค่ไหน',
        a: 'รูปแบบที่ใช้เวลาสะสมนานมักให้การเคลื่อนไหวใหญ่กว่า แต่ก็ไม่ใช่หลักประกัน สิ่งสำคัญคือไม่เข้าก่อนที่ราคาจะเลือกทาง',
        a2: 'ตัวเลขที่ใช้ได้คือ สามเหลี่ยมที่สะสมนาน 30-50 แท่งมักให้การเคลื่อนไหว 1.5-2 เท่าของความสูงรูปแบบ ส่วนที่สะสมไม่ถึง 15 แท่งมักหลุดแล้วกลับเข้ากรอบ ถ้ายังไม่ถึงครึ่งทางของรูปแบบ ควรลดขนาดสถานะลง',
      },
    ],
    related: ['chart-pattern-reading', 'flag-pattern', 'support-resistance-breakout'],
  },
  {
    slug: 'flag-pattern',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'Flag Pattern คืออะไร',
    description:
      'อ่านรูปแบบธงและการพักราคาหลังการเคลื่อนไหวแรง พร้อมวิธีแยกรูปแบบนี้จากการกลับตัว',
    readingTime: '7 นาที',
    updatedDate: '2026-10-06',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20flag%20pattern%20chart%20illustration%20teal%20steep%20move%20then%20tight%20consolidation%20inside%20warm%20orange%20parallel%20channel%20clean%20light%20background%20editorial%20flat%20fintech%20no%20text&width=1200&height=675&seq=art-flag-pattern-01&orientation=landscape',
    tags: ['รูปแบบกราฟ', 'ธง', 'พักราคา'],
    intro: [
      'Flag Pattern คือรูปแบบการพักราคาหลังการเคลื่อนไหวแรง โดยราคาแกว่งแคบลงในกรอบเอียงสวนทางกับการเคลื่อนไหวเดิมชั่วคราว',
      'รูปแบบนี้สะท้อนว่าตลาดกำลังพักหายใจ ไม่ได้เปลี่ยนทิศทาง',
    ],
    sections: [
      {
        id: 'shape',
        heading: 'หน้าตาของธง',
        paragraphs: [
          'ก่อนเกิดธงมักมีแท่งใหญ่ต่อเนื่องกันเรียกว่าเสาธง จากนั้นราคาแกว่งแคบลงในกรอบขนานที่เอียงสวนทางเล็กน้อย และมักใช้เวลาไม่นานนัก',
        ],
        bullets: ['ต้องมีเสาธงที่ชัดเจนก่อน', 'กรอบพักควรแคบและสั้น', 'ยิ่งพักสั้น รูปแบบยิ่งสมบูรณ์'],
        steps: [],
      },
      {
        id: 'read',
        heading: 'วิธีอ่านและรอ',
        paragraphs: [
          'รอให้ราคาปิดพ้นกรอบธงในทิศทางเดิมของการเคลื่อนไหวก่อน ถ้าราคาแกว่งนานเกินไปหรือกว้างขึ้นเรื่อย ๆ รูปแบบอาจกลายเป็นการกลับตัวแทน',
        ],
        bullets: ['รอแท่งปิดพ้นกรอบ', 'ตรวจว่าจะมีแรงตามมาหรือไม่', 'ลดขนาดเมื่อรูปแบบยืดเยื้อ'],
        steps: [],
      },
      {
        id: 'limit',
        heading: 'ข้อจำกัด',
        paragraphs: [
          'ธงเป็นรูปแบบที่เห็นได้บ่อยจนถูกมองเห็นในทุกการพักราคา การฝืนวาดกรอบให้พอดีกับสิ่งที่อยากเห็นคือสาเหตุหลักที่ทำให้รูปแบบนี้ใช้ไม่ได้',
          'เกณฑ์ที่ช่วยกรองคือเสาธงควรยาวอย่างน้อย 40 ถึง 60 Pip บน H1 และช่วงพักต้องย้อนกลับไม่เกิน 38.2 ถึง 50% ของเสา ถ้าพักนานเกิน 15 แท่งหรือย้อนเกิน 61.8% ให้ถือว่าไม่ใช่ธงแล้ว เพราะแรงที่ดันราคามักหมดก่อนที่ราคาจะทะลุออกไป',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ธงกับสามเหลี่ยมต่างกันอย่างไร',
        a: 'ธงมีกรอบขนานและมาหลังการเคลื่อนไหวแรง ส่วนสามเหลี่ยมมีเส้นบรรจบกันและไม่จำเป็นต้องมีเสาธงนำ',
        a2: 'ตัวอย่างที่แยกได้คือ ธงมักพักเพียง 5-15 แท่งหลังเสาธงที่เคลื่อน 60-100 Pip ส่วนสามเหลี่ยมใช้เวลาสะสม 20-50 แท่ง และไม่ต้องมีเสาธงนำหน้า การนับแท่งช่วยให้ไม่สับสนระหว่างสองรูปแบบ',
      },
      {
        q: 'ธงใช้กับกรอบเวลาไหนดี',
        a: 'ใช้ได้ทุกกรอบ แต่ธงบนกรอบกลางถึงใหญ่จะมีความหมายกว่าและมีสัญญาณรบกวนน้อยกว่า',
        a2: 'ตัวเลขที่ต่างชัดคือ ธงบน M5 เกิดวันละหลายครั้งและล้มเหลวราว 6-7 ใน 10 ครั้ง ส่วนบน H4 เกิดสัปดาห์ละ 1-2 ครั้งและสำเร็จราว 5-6 ใน 10 ครั้ง ความต่างนี้มาจากสัญญาณรบกวนที่ต่างกันหลายเท่า',
      },
    ],
    related: ['triangle-pattern', 'chart-pattern-reading', 'forex-trend-direction'],
  },
  {
    slug: 'chart-pattern-reading',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'วิธีอ่านรูปแบบกราฟโดยไม่รีบสรุปทิศทางราคา',
    description:
      'หลักคิดในการอ่านรูปแบบกราฟอย่างมีวินัย รู้ว่าอะไรคือหลักฐาน อะไรคือการเดา และควรใช้รูปแบบร่วมกับอะไร',
    readingTime: '8 นาที',
    updatedDate: '2026-10-05',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20chart%20pattern%20study%20illustration%20teal%20price%20shapes%20with%20warm%20orange%20annotation%20frames%20on%20clean%20light%20background%20editorial%20flat%20fintech%20no%20text&width=1200&height=675&seq=art-chart-pattern-reading-01&orientation=landscape',
    tags: ['รูปแบบกราฟ', 'วินัย', 'วิเคราะห์'],
    intro: [
      'รูปแบบกราฟเป็นเครื่องมือจัดระเบียบสิ่งที่เห็น ไม่ใช่คำพยากรณ์ การอ่านอย่างมีวินัยจึงสำคัญกว่าการจำชื่อรูปแบบได้ครบ',
      'บทความนี้สรุปหลักคิดที่ช่วยให้การอ่านรูปแบบมีประโยชน์จริง',
    ],
    sections: [
      {
        id: 'evidence',
        heading: 'แยกหลักฐานออกจากการเดา',
        paragraphs: [
          'หลักฐานคือสิ่งที่กราฟแสดงแล้ว เช่น ระดับที่ถูกแตะซ้ำหรือแท่งที่ปิดผ่านโซน ส่วนการเดาคือการคาดว่าอะไรจะเกิดต่อไป ควรเขียนสองอย่างนี้แยกกันก่อนตัดสินใจ',
        ],
        bullets: ['ระบุสิ่งที่เห็นได้จริงก่อน', 'เขียนสมมติฐานแยกออกมา', 'กำหนดอะไรจะทำให้สมมติฐานผิด'],
        steps: [],
      },
      {
        id: 'context',
        heading: 'บริบทมาก่อนรูปแบบ',
        paragraphs: [
          'รูปแบบเดียวกันในบริบทต่างกันให้ความหมายต่างกัน รูปแบบกลับตัวที่เกิดต้นขาขึ้นมักล้มเหลว ในขณะที่รูปแบบเดิมที่เกิดปลายขาขึ้นมีน้ำหนักกว่า',
        ],
        bullets: ['ดูแนวโน้มหลักก่อน', 'ดูตำแหน่งเทียบโซนสำคัญ', 'ตรวจกรอบเวลาใหญ่อีกครั้ง'],
        steps: [],
      },
      {
        id: 'discipline',
        heading: 'วินัยในการใช้',
        paragraphs: [
          'กำหนดเกณฑ์ล่วงหน้าว่าจะรออะไร จึงไม่ต้องตัดสินใจใหม่ทุกครั้งที่กราฟขยับ และบันทึกผลลัพธ์ไว้ทบทวนเพื่อดูว่ารูปแบบไหนได้ผลกับสไตล์ของตัวเอง',
          'การบันทึกที่ได้ผลควรมีอย่างน้อย 6 ช่อง คือ วันที่ คู่เงิน รูปแบบ จุดเข้า จุดออก ผลลัพธ์เป็น Pip และเหตุผลที่เข้า เมื่อเก็บได้ 50 ไม้จะเริ่มเห็นว่าตัวเองได้ผลกับรูปแบบไหนจริง ๆ ซึ่งบางคนพบว่าได้กำไรเฉพาะรูปแบบเดียวและควรตัดรูปแบบอื่นออกทั้งหมด',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'รูปแบบกราฟยังใช้ได้ในปัจจุบันไหม',
        a: 'ใช้ได้ในฐานะเครื่องมือจัดระเบียบข้อมูล แต่ไม่ควรใช้เป็นการพยากรณ์ เพราะตลาดเปลี่ยนสภาพได้ตลอดเวลา',
        a2: 'ตัวเลขที่ควรจำคือ แม้ระบบชนะ 55% ก็ยังมีช่วงขาดทุนติดกัน 4-5 ครั้งใน 100 ไม้ สิ่งที่ทำให้อยู่รอดไม่ใช่การอ่านรูปแบบแม่นขึ้น แต่คือความเสี่ยง 1% ต่อไม้และการบันทึกผลอย่างต่อเนื่อง',
      },
      {
        q: 'ควรจดบันทึกรูปแบบที่เจอไหม',
        a: 'ควรอย่างยิ่ง การจดว่าพบรูปแบบที่ไหนและผลออกมาเป็นอย่างไรช่วยให้เห็นว่าอะไรได้ผลกับตัวเองจริง',
        a2: 'วิธีที่ใช้ได้คือจด 3 อย่างต่อครั้ง คือ ชื่อรูปแบบ กรอบเวลา และผลลัพธ์เป็น Pip เก็บให้ครบ 30-50 ครั้งต่อรูปแบบ แล้วเปรียบอัตราสำเร็จของแต่ละแบบ นี่คือข้อมูลที่บอกได้ว่าควรใช้รูปแบบไหนกับสไตล์ของคุณ',
      },
    ],
    related: ['head-and-shoulders', 'double-top-double-bottom', 'price-action'],
  },
  {
    slug: 'support-resistance-with-indicators',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'วิธีใช้แนวรับแนวต้านร่วมกับอินดิเคเตอร์',
    description:
      'แนวทางรวมโซนราคาสำคัญเข้ากับอินดิเคเตอร์ยืนยัน โดยไม่ให้สัญญาณขัดกันจนตัดสินใจไม่ได้',
    readingTime: '8 นาที',
    updatedDate: '2026-10-04',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20chart%20combining%20horizontal%20support%20zone%20with%20teal%20moving%20average%20line%20and%20small%20oscillator%20panel%20clean%20light%20background%20editorial%20flat%20fintech%20no%20text&width=1200&height=675&seq=art-support-with-indicators-01&orientation=landscape',
    tags: ['แนวรับแนวต้าน', 'อินดิเคเตอร์', 'วิธีวิเคราะห์'],
    intro: [
      'แนวรับแนวต้านบอกว่าที่ไหนควรให้ความสนใจ ส่วนอินดิเคเตอร์บอกว่าจังหวะนั้นมีแรงสนับสนุนหรือไม่',
      'การใช้สองอย่างร่วมกันจึงเป็นการแบ่งหน้าที่ ไม่ใช่การเอามาเถียงกัน',
    ],
    sections: [
      {
        id: 'order',
        heading: 'ลำดับที่ควรใช้',
        paragraphs: [
          'เริ่มจากโซนราคาก่อนเสมอ เพราะเป็นข้อมูลตรงจากตลาด จากนั้นจึงดูอินดิเคเตอร์ว่าสนับสนุนการตอบสนองที่คาดไว้หรือไม่',
        ],
        bullets: ['โซนกำหนดจุดสนใจ', 'อินดิเคเตอร์ยืนยันจังหวะ', 'ถ้าขัดกัน ให้ยึดโซนและลดขนาด'],
        steps: [],
      },
      {
        id: 'example',
        heading: 'ตัวอย่างการใช้งาน',
        paragraphs: [
          'สมมติราคาลงมาที่โซนแนวรับสำคัญซึ่งถูกแตะมาสองครั้งก่อนหน้า และ RSI เริ่มกลับขึ้นจากโซนต่ำ สองข้อมูลนี้สนับสนุนกัน แต่ยังต้องรอสัญญาณจากแท่งเทียนยืนยัน',
        ],
        bullets: ['อย่าเข้าทันทีที่ราคาถึงโซน', 'รอการตอบสนองของราคาจริง', 'กำหนดจุดผิดใต้โซน ไม่ใช่กลางโซน'],
        steps: [],
      },
      {
        id: 'avoid',
        heading: 'ข้อผิดพลาดที่ควรเลี่ยง',
        paragraphs: [
          'การวางอินดิเคเตอร์หลายตัวพร้อมกันเพื่อให้ได้สัญญาณที่ต้องการ และการย้ายโซนให้ตรงกับสัญญาณ ล้วนทำให้การวิเคราะห์หมดความหมาย',
          'ทางที่ดีคือเลือกอินดิเคเตอร์ไม่เกิน 2 ตัวที่ทำหน้าที่ต่างกัน เช่น หนึ่งตัวดูแนวโน้มและหนึ่งตัวดูโมเมนตัม แล้วยอมรับว่าบางวันก็ไม่มีสัญญาณเลย ในความเป็นจริงการรอสัญญาณที่ตรงเกณฑ์ทั้งหมดอาจใช้เวลา 3 ถึง 5 วัน ซึ่งปกติกว่าการเทรดทุกวันมาก',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ควรใช้อินดิเคเตอร์กี่ตัว',
        a: 'หนึ่งถึงสองตัวก็เพียงพอสำหรับการยืนยัน การเพิ่มจำนวนไม่ได้เพิ่มคุณภาพของข้อมูล แต่เพิ่มความขัดแย้ง',
        a2: 'ตัวเลขที่ใช้ได้คือใช้อินดิเคเตอร์ 1 ตัวยืนยันโซนราคา เช่น RSI ที่โซนแนวรับ หรือ MA ที่สอดคล้องแนวโน้ม ถ้าเพิ่มเป็น 3 ตัว คุณจะเจอสัญญาณขัดกันราว 4-5 ใน 10 ครั้ง และมักเลือกเชื่อตัวที่ตรงกับที่อยากเข้า',
      },
      {
        q: 'ถ้าอินดิเคเตอร์บอกทางหนึ่งแต่โซนบอกอีกทาง',
        a: 'ให้ถือว่าเป็นการไม่ยืนยันกัน ในกรณีนี้มักดีที่สุดคือรอหรือไม่เปิดออเดอร์',
        a2: 'ตัวเลขที่ช่วยตัดสินคือ ถ้าสัญญาณขัดกัน ให้ลดขนาดสถานะลงครึ่งหนึ่งหรือข้ามไม้ไปเลย เพราะการเทรดที่ไม่มีข้อมูลสนับสนุนมักให้ผลแย่กว่าการไม่เทรด และควรบันทึกกรณีนี้ไว้ด้วยเพื่อดูว่าการข้ามไม้ช่วยลดการขาดทุนได้จริงหรือไม่',
      },
    ],
    related: ['support-resistance', 'technical-indicators', 'how-to-analyze-forex-chart'],
  },
];